import { PrintProps } from 'approot/activity-builder/components/columns/columns.constants';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/columns/settings/column-settings.utils';
import ActivityAnswersPrintColumnsComponents from './activity-answers-print-columns-components';
import * as Styled from 'approot/activity-builder/components/columns/columns-print.style';
import { LanguageCodes } from 'global/constants';

const ActivityAnswersPrintColumns = ({
  columns,
  columnProperties,
  previewType,
  language,
  onRenderComplete,
  studentId,
  contentVersion,
}: PrintProps & {
  previewType: string;
  language: LanguageCodes;
  onRenderComplete?: () => void;
  studentId?: number;
  contentVersion: string | null | undefined;
}) => {
  return (
    <Styled.ColumnsPrintContainer
      $colours={getAppliedColour(columnProperties?.style)}
      $showBackground={isBackgroundApplied(columnProperties?.style)}
      $showBorder={isBorderApplied(columnProperties?.style)}
      $turnOffResponsive
    >
      {columns?.map(column => (
        <Styled.ColumnsPrintColumn
          key={column.columnId}
          $colspan={column.colspan}
          $alignment={column.alignment}
          $colours={getAppliedColour(column.style)}
          $showBorder={isBorderApplied(column.style)}
          $showBackground={isBackgroundApplied(column.style)}
          $turnOffResponsive
        >
          <ActivityAnswersPrintColumnsComponents
            column={column}
            language={language}
            onRenderComplete={onRenderComplete}
            studentId={studentId}
            previewType={previewType}
            contentVersion={contentVersion}
          />
        </Styled.ColumnsPrintColumn>
      ))}
    </Styled.ColumnsPrintContainer>
  );
};

export default ActivityAnswersPrintColumns;
